// extracted by mini-css-extract-plugin
export var numpadContainer = "_j9-1";
export var phoneButton = "_j9-0";